// api/stores.ts
import { apiClient } from './client';

export const storesAPI = {
  getStores: async (params?: { is_active?: boolean }) => {
    const response = await apiClient.get('/vendors/stores/', { params });
    return response.data;
  },

  getStore: async (id: number) => {
    const response = await apiClient.get(`/stores/${id}/`);
    return response.data;
  },

  createStore: async (data: any) => {
    const response = await apiClient.post('/stores/', data);
    return response.data;
  },

  updateStore: async (id: number, data: any) => {
    const response = await apiClient.patch(`/stores/${id}/`, data);
    return response.data;
  },

  deleteStore: async (id: number) => {
    const response = await apiClient.delete(`/stores/${id}/`);
    return response.data;
  },
};